import React from 'react';
import singleTenantTables from './single-tenant-tables/index';
import Textarea from '../Textarea';
import markets from '../../markets';
import propertyCategories from '../../property-categories';
import propertyTypes from '../../property-types';
import leaseTypes from '../../lease-types';
import unitedStates from 'united-states';
import request from "arcdynamic-request";
import { stringProps, dateProps, numberProps, vacantChanges, leaseChanges } from "./stnl-fields-to-save";
import Icon from "../Icon";
import svgPlace from "../../svgs/place.svg";
import { stringUStoISO, stringISOtoUS, stringUStoUS, dateToUS, dateToUsString, isMtm, normalizeMtm } from '../../date-converter';
import guarantor from '../../guarantor';
import optionsToPurchase from '../../options-to-purchase';
import PrintSingleTenant from "../PrintSingleTenant";
import { addCommasToNumber, isValidPriceChange } from "../../utils";
import { mergePropertySingletonRows } from '../../utils/mergePropertySingletonRows';
import { UNDERWRITING_SINGLE_TENANT, UNDERWRITING_RENT_SCHEDULE, PRICING_ANALYSIS } from '../../consts/tables';
import { buildRentScheduleRow } from "./single-tenant-tables/rent-schedule";
import { buildOperatingDataRow } from "./single-tenant-tables/annualized-operating-data";
import plusIcon from "../../svgs/plus-button.svg";
import minusIcon from "../../svgs/minus-button.svg";
import { getData } from '../../requests/CRUD';
import PopupDialog from '../PopupDialog/PopupDialog';
import { getCurrentAccess } from '../../access';
import { editsEverySummitRecord } from '../../access-levels';

const cloneDeep = require('lodash.clonedeep');
const findIndex = require('lodash.findindex');
export const operatingDataNo = 11;
const monthlyRentIndex = 0;
const currentYearsIndex = 0;
const leaseCommencementIndex = 1;
const increaseIndex = 3;

function getLastYearValue(yearsValue) {
    if (!yearsValue) return 0;

    const normalizedYears = `${yearsValue}`.trim();
    const yearMatches = normalizedYears.match(/\d+/g);
    return yearMatches && yearMatches.length ? parseInt(yearMatches[yearMatches.length - 1], 10) : 0;
}

function preProcess(items) {
    const ITEMS = JSON.parse(items)
    return ITEMS.map((val) => val.link)
}
const defualtStaticImages = [
    '1dc5da0b5ccd7a2e0647bdb85e81f341d7227787d0790c66b17d497150fa7a9231bbd908a08f35ae39da59b9a8461f97421a7d76c1163bf8b7d70497e33a2c7c_STNL_image_2.jpg',
    '4f35f49f424d9a058e2deb44b690792099973f46137fdf4a2655f93c6b907d1edb796c6db25c1b8d5f2c248ef8934587a02ce1b46f6682895296c2fd98da61f4_STNL_image_3.jpg',
    'a09a999b0841ec7f8886ea6ad6d1a7de245b6d91d6414c6b3240abe99c7aa724802cf90d30df80122efa36cb30986225cb99550dff3fbce32f042b740366a2ec_STNL_image_4.jpg',
    'b5d6c9c57e55eb1bbb6498b8d1b207c95abf096611921a3d053c2ca9e250334af65eda3c3f753827a89eabe30f3e741439654482d28401ce1858b4a5019c6ee1_STNL_image_5.jpg',
    '9065ff19a15d1ae652076b65801a850a730da4350c64c80b5ba5b5249b3957f32f368de5100878005fc23072ca453dbce5e2c4f4012fe27c418b53e7ceb471dd_STNL_image_6.jpg',
    '30c89b78cbbe653bbd5b6adbea9a9c177b60c7f77b992c2b70b28a6c56b5b6ab6fa98db70d320da72a33ec1f5bf7418dde0f45892e75d8869db63b132cd7bb9d_STNL_image_7.jpg',
    'eb0020a25c305a06be6e6af9cd184b90a4874e456b06c06260e058967feb97744470fe54b381a864235b944d9e08502fdbfc6af3316f0099fa4d4231f58d1587_STNL_image_8.jpg',
    'f89d31ddae358e0b9b2333d00947a5ba759fee05f08e724d66447ff8112b0a590dda20fc3c4384e5439664947f5f6044eab261024ad7d46c79d804c26a31fdc3_STNL_image_9.jpg',
    'cf7cd88c9a85eb575a3042302ae3d003ab37abb868bab56d3811efd016ade4a6004343cbec2f260966463942b4c1f5de344b0828cd9fa9930528ef8a37a33191_STNL_image_10.jpg',
];

export default class UnderwritingSingleTenant extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            data: {
                tables: singleTenantTables
            },
            original: {
                tables: singleTenantTables
            },
            rentScheduleData: null,
            newData: null,
            underwritingId: null,
            displayPopupSubmit: false,
            isAdditionalPriceVisible: false,
            staticImages: [],
            staticImagesLoaded: false,
            staticImagesLoading: true,
            isBusy: false,
            isDialogueOpen: false,
            dialogTitle: '',
            isCaliforniaProposal: false
        };

        this.getUnderwritingData = this.getUnderwritingData.bind(this);
        this.setUnderwritingData = this.setUnderwritingData.bind(this);
        this.onTableValueChange = this.onTableValueChange.bind(this);
        this.onTableValueBlur = this.onTableValueBlur.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.togglePopupMessage = this.togglePopupMessage.bind(this);
        this.addRow = this.addRow.bind(this);
        this.deleteRow = this.deleteRow.bind(this);
        this.handleExpand = this.handleExpand.bind(this);
        this.getStaticImages = this.getStaticImages.bind(this);
        this.getProductType = this.getProductType.bind(this);
        this.handleCaliforniaToggle = this.handleCaliforniaToggle.bind(this);
        this.onConfirm = this.onConfirm.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.beforeSubmit = this.beforeSubmit.bind(this);
    }

    static calculateMonthlyRents(tables) {
        const t = cloneDeep(tables);
        const rentScheduleRows = t['rent-schedule'].rows;
        const operatingDataRows = t['annualized-operating-data'].rows;
        Object.keys(rentScheduleRows).forEach(key => {
            if (['0', '1'].includes(key) || !operatingDataRows[key].valueCells[0].value) return;
            const prevIncrease = operatingDataRows[key - 1].valueCells[increaseIndex].getComputedValue(t, key - 1).internalValue;
            if (!prevIncrease) return;
            const prevMonthlyRent = rentScheduleRows[key - 1].valueCells[monthlyRentIndex].value;
            rentScheduleRows[key].valueCells[monthlyRentIndex].value = (prevMonthlyRent * (prevIncrease / 100 + 1)).toFixed(2);
        });

        return t;
    }

    static calculateLeaseCommencement(tables, closeOfEscrow) {
        const t = cloneDeep(tables);
        const operatingDataRows = t['annualized-operating-data'].rows;

        Object.keys(operatingDataRows).forEach(key => {
            const leaseCommencement = t['lease-summary'].rows['lease-commencement'].editable ? t['lease-summary'].rows['lease-commencement'].value || '' : t['lease-summary'].rows['lease-commencement'].getComputedValue(t, '', closeOfEscrow).internalValue;
            const leaseExpiration = t['lease-summary'].rows['lease-expiration'].editable ? t['lease-summary'].rows['lease-expiration'].value || '' : t['lease-summary'].rows['lease-expiration'].getComputedValue(t, '', closeOfEscrow).internalValue;

            if (isMtm(leaseExpiration)) {
                operatingDataRows[0].valueCells[currentYearsIndex].value = normalizeMtm(leaseExpiration);
            }

            const currentYears = t['annualized-operating-data'].rows[key].valueCells[currentYearsIndex].value;

            if (key === '0') {
                operatingDataRows[key].valueCells[leaseCommencementIndex].value = dateToUS(leaseCommencement) || leaseCommencement;
                return;
            }

            if (!isMtm(leaseCommencement) && !isMtm(leaseExpiration)) {
                const previousYears = t['annualized-operating-data'].rows[key - 1].valueCells[currentYearsIndex].value;

                if (currentYears && previousYears && leaseCommencement) {
                    const leaseCommencementDate = new Date(`${stringUStoISO(dateToUS(leaseCommencement) || leaseCommencement)}T00:00:00`);
                    const lastYearValue = getLastYearValue(previousYears);

                    if (lastYearValue && !Number.isNaN(leaseCommencementDate.getTime())) {
                        leaseCommencementDate.setFullYear(leaseCommencementDate.getFullYear() + lastYearValue);
                        operatingDataRows[key].valueCells[leaseCommencementIndex].value = dateToUsString(leaseCommencementDate);
                    } else {
                        operatingDataRows[key].valueCells[leaseCommencementIndex].value = '';
                    }
                }
            }
        });

        return t;
    }

    componentDidMount() {
        this.getUnderwritingData();
        this.getStaticImages(this.getProductType());
        this.injectPrintPageSize();
    }

    componentWillUnmount() {
        this.removePrintPageSize();
    }

    injectPrintPageSize() {
        if (typeof document === 'undefined' || this._printPageStyles) return;
        // Landscape on a REAL paper size (letter) so the layout maps 1:1 onto the
        // sheet with no driver scale-to-fit. Each proposal sheet is a fixed
        // 1056x810px design (letter landscape at 96dpi), scaled to fit whatever
        // printable area the print dialog produces: in print media 100vw/100vh equal
        // the page area (paper minus the dialog's margins), so
        // zoom: min(100vw/width, 100vh/height) fills the width edge-to-edge at
        // Margins: None and shrinks just enough at Minimum/Default — each section
        // always lands whole on its own page at 100% scale, on Letter or A4.
        // Denominators carry ~0.4% slack (1060/813 vs 1056/810) so rounding can
        // never spill a 1px sliver onto an extra page. The static zoom before it is
        // the fallback for engines without calc() length division (pre-2024).
        //
        // `zoom` (not transform) because Chromium paginates on zoomed layout. The
        // root width is pinned in PX, not %: Blink zooms px lengths but resolves %
        // widths against the parent unshrunk, so a %-width root would keep sheets
        // full-width while their px heights shrink — distorting the aspect and
        // letterboxing every object-fit image. A px base scales uniformly; auto
        // margins center the scaled sheets on the page.
        const css = '@media print {'
            + ' @page { size: letter landscape !important; margin: 0 !important; }'
            + ' .SingleTenant, .PrintMultiTenant {'
            + ' zoom: 0.93;'
            + ' zoom: min(calc(100vw / 1060px), calc(100vh / 813px));'
            + ' width: 1056px !important; max-width: none !important;'
            + ' margin-left: auto !important; margin-right: auto !important;'
            + ' } }';
        const first = document.createElement('style');
        first.setAttribute('data-proposal-page-size', 'first');
        first.innerHTML = css;
        const last = document.createElement('style');
        last.setAttribute('data-proposal-page-size', 'last');
        last.innerHTML = css;
        document.head.insertBefore(first, document.head.firstChild);
        document.head.appendChild(last);
        this._printPageStyles = [first, last];
    }

    removePrintPageSize() {
        (this._printPageStyles || []).forEach((s) => s.parentNode && s.parentNode.removeChild(s));
        this._printPageStyles = null;
    }

    getProductType() {
        const category = this.props.data.CATEGORY;
        if (category === 'apartments') return 'apartments';

        const isVacant = (this.props.data.SINGLE_TENANT_SUBCATEGORY && this.props.data.SINGLE_TENANT_SUBCATEGORY.toLowerCase().includes('vacant'))
            || (this.props.data.LEASE_TYPE && this.props.data.LEASE_TYPE.toLowerCase().includes('vacant'));

        // California toggle only applies to retail properties and overrides the vacant suffix
        // because no `retail-STNL-CA-vacant` product type exists.
        if (category === 'retail' && this.state.isCaliforniaProposal) {
            return 'retail-STNL-CA';
        }

        let type = category + '-STNL';
        if (isVacant) type = type + '-vacant';
        return type;
    }

    handleCaliforniaToggle() {
        this.setState(
            (prev) => ({ isCaliforniaProposal: !prev.isCaliforniaProposal }),
            () => { this.getStaticImages(this.getProductType()); }
        );
    }

    getUnderwritingData(isSaved) {
        let data = cloneDeep(this.state.data);

        // Set the dropdown values
        data.tables['general-information'].rows['state'].dropdownValues = unitedStates;
        data.tables['general-information'].rows['market'].dropdownValues = markets;
        data.tables['general-information'].rows['property-category'].dropdownValues = propertyCategories;
        data.tables['general-information'].rows['property-type'].dropdownValues = propertyTypes;
        data.tables['lease-summary'].rows['lease-type'].dropdownValues = leaseTypes;
        data.tables['lease-summary'].rows['guarantor'].dropdownValues = guarantor;
        data.tables['lease-summary'].rows['options-to-purchase'].dropdownValues = optionsToPurchase;

        if (this.props.historySnapshot && this.props.historySnapshot.singleTenant) {
            const snapshot = this.props.historySnapshot.singleTenant;
            const res = [
                { success: true, data: [snapshot.underwriting || {}] },
                { success: true, data: Array.isArray(snapshot.rentSchedule) ? snapshot.rentSchedule : [] },
            ];
            this.setUnderwritingData(res, data, false);
            return;
        }

        if (!this.props.data.ARCIMEDES_ROW_ID) {
            this.setState({
                data: data,
                original: cloneDeep(data)
            });
            return;
        }

        let id = this.props.data.ARCIMEDES_ROW_ID;
        if (id && typeof (id) !== 'string') {
            id = this.props.data.ARCIMEDES_ROW_ID.toString();
        }

        Promise.all([
            request(arc.path.api, {
                service: 'arcimedes',
                action: 'open.datasource.table.Data.getData',
                params: ['code', UNDERWRITING_SINGLE_TENANT, {
                    filter: [{
                        'text': id,
                        'code': 'PROPERTY_ID',
                        'type': 'exact',
                    }],
                }],
            }),
            request(arc.path.api, {
                service: 'arcimedes',
                action: 'open.datasource.table.Data.getData',
                params: ['code', UNDERWRITING_RENT_SCHEDULE, {
                    filter: [{
                        'text': id,
                        'code': 'PROPERTY_ID',
                        'type': 'exact',
                    }, {
                        'text': '',
                        'code': 'DELETED',
                        'type': 'null',
                    }],
                    filterType: 'and',
                    order: [{
                        code: 'ARCIMEDES_ROW_ID',
                        type: 'asc',
                    }]
                }],
            }),
        ]).then(res => {
            if (res)
                this.setUnderwritingData(res, data, isSaved);
        });
    }

    setUnderwritingData(res, data, isSaved) {
        const propsData = this.props.data;
        const annualizedOperatingData = data.tables['annualized-operating-data'];
        const rentSchedule = data.tables['rent-schedule'];
        let rentScheduleData = null;

        // Manage data from PROPERTIES table
        stringProps.map(prop => {
            // get property props
            if (propsData.hasOwnProperty(prop.key)) {
                data.tables[prop.table].rows[prop.tableKey].value = propsData[prop.key] || '';
            }
        });

        dateProps.map(prop => {
            // get property props
            if (propsData.hasOwnProperty(prop.key)) {
                data.tables[prop.table].rows[prop.tableKey].value = propsData[prop.key] ? dateToUS(propsData[prop.key]) : '';
            }
        });

        numberProps.map(prop => {
            // get property props

            if (propsData.hasOwnProperty(prop.key)) {

                if (prop.table === 'pricing-rent-matrix' && (prop.key === 'SQFT' || prop.key === 'CAPITALIZATION_RATE')) {
                    data.tables[prop.table].rows[prop.tableKey].valueCells[prop.valueCellIndex].value = propsData[prop.key] ? parseFloat(propsData[prop.key].replace(/,/g, '')) : '';
                    return
                }

                if (prop.withReplace && prop.withToFixed) {
                    data.tables[prop.table].rows[prop.tableKey].value = propsData[prop.key] ? parseFloat(propsData[prop.key].replace(/,/g, '')).toFixed(2) : '';
                    return;
                }
                if (prop.withToFixed) {
                    data.tables[prop.table].rows[prop.tableKey].value = propsData[prop.key] ? parseFloat(propsData[prop.key]).toFixed(2) : '';
                    return;
                }
                if (prop.withReplace) {
                    data.tables[prop.table].rows[prop.tableKey].value = propsData[prop.key] ? parseFloat(propsData[prop.key].replace(/,/g, '')) : '';
                    return;
                }
                data.tables[prop.table].rows[prop.tableKey].value = parseFloat(propsData[prop.key]) || '';
            }
        });

        // Manage data from UNDERWRITING_SINGLE_TENANT table
        if (res[0] && res[0].success && Array.isArray(res[0].data)) {
            const result = mergePropertySingletonRows(res[0].data);

            stringProps.map(prop => {
                // get underwriting data
                if (!propsData.hasOwnProperty(prop.key)) {
                    const defaultValue = prop.defaultValue ? prop.defaultValue : '';
                    data.tables[prop.table].rows[prop.tableKey].value = result[prop.key] || defaultValue;
                }
            });

            dateProps.map(prop => {
                // get underwriting data
                if (!propsData.hasOwnProperty(prop.key)) {
                    data.tables[prop.table].rows[prop.tableKey].value = result[prop.key] ? stringISOtoUS(result[prop.key]) : '';
                }
            });

            numberProps.map(prop => {
                // get underwriting data
                if (!propsData.hasOwnProperty(prop.key)) {
                    if (prop.hasOwnProperty('valueCellIndex')) {
                        const defaultValue = prop.defaultValue || '';
                        if (prop.withToFixed) {
                            data.tables[prop.table].rows[prop.tableKey].valueCells[prop.valueCellIndex].value = result[prop.key] ? parseFloat(result[prop.key]).toFixed(2) : defaultValue;
                            return;
                        }
                        data.tables[prop.table].rows[prop.tableKey].valueCells[prop.valueCellIndex].value = parseFloat(result[prop.key]) || defaultValue;
                    } else {
                        data.tables[prop.table].rows[prop.tableKey].value = parseFloat(result[prop.key]) || '';
                    }
                }
            });

            const addition_type_enum = {
                name: 'Taxes',
                name2: 'Insurance',
                name3: 'CAM',
                name4: 'Management Fee'
            }

            data.tables['annualized-operating-data'].footerRow.forEach((e, index) => {
                const _index = index > 1 ? index : '';
                e.valueCells[0].value = result['ADDITION_TYPE' + _index] || addition_type_enum['name' + _index];
                e.valueCells[2].value = parseInt(result['ADDITION_VALUE' + _index]) || '';
            });
        }

        // Manage data from UNDERWRITING_RENT_SCHEDULE table
        if (res[1] && res[1].success && Array.isArray(res[1].data)) {
            const result = res[1].data;
            rentScheduleData = result;
            const no = result.length > operatingDataNo ? result.length : operatingDataNo;

            rentSchedule.rows = Object.assign({}, new Array(no).fill(null).map((row, index) => {
                const rowData = result[index] ? result[index] : {};
                return buildRentScheduleRow(rowData);
            }));
            const isSaleLeaseBack = data.tables['general-information']['rows']['sale-lease-back'].value;
            annualizedOperatingData.rows = Object.assign({}, new Array(no).fill(null).map((row, index) => {
                const rowData = result[index] ? result[index] : {};
                return buildOperatingDataRow(rowData, isSaleLeaseBack === 'Yes');
            }));

            if (result && result[0] && !result[0].LEASE_COMMENCEMENT)
                data.tables = UnderwritingSingleTenant.calculateLeaseCommencement(data.tables, propsData.CLOSE_OF_ESCROW);
            data.tables['pricing-rent-matrix'].rows['base-rent-psf'].valueCells[0].value = (data.tables['rent-schedule'].rows[0].valueCells[1].getComputedValue(data.tables, 0).internalValue && data.tables['rent-schedule'].rows[0].valueCells[1].getComputedValue(data.tables, 0).internalValue !== "NaN") ? data.tables['rent-schedule'].rows[0].valueCells[1].getComputedValue(data.tables, 0).internalValue : ""
            const bpsChangeValue = data.tables['pricing-rent-matrix'].rows['rent-adjustment'].valueCells[6].value;
            const capRate = data.tables['pricing-rent-matrix'].rows['base-rent-psf'].valueCells[6].value;
            const anticipatedPrice = bpsChangeValue + capRate
            const conservativePrice = anticipatedPrice + bpsChangeValue
            data.tables['pricing-rent-matrix'].rows['price-percentages'].valueCells[3].value = isValidPriceChange(data.tables['pricing-rent-matrix'].rows['price-percentages'].valueCells[3].value);
            data.tables['pricing-rent-matrix'].rows['price-percentages'].valueCells[4].value = isValidPriceChange(anticipatedPrice);
            data.tables['pricing-rent-matrix'].rows['price-percentages'].valueCells[5].value = isValidPriceChange(conservativePrice);
        }

        const leaseType = data.tables['lease-summary'].rows['lease-type'].value;
        data.tables = UnderwritingSingleTenant.changeVacantView(data.tables, leaseType);

        const isSaleLeaseBack = data.tables['general-information'].rows['sale-lease-back'].value;
        data.tables = UnderwritingSingleTenant.changeLeaseView(data.tables, isSaleLeaseBack);

        // set sale lease back default to "No" if none of options are selected
        if (!isSaleLeaseBack) {
            data.tables['general-information'].rows['sale-lease-back'].value = "No"
        }

        this.setState({
            data: data,
            original: cloneDeep(data),
            rentScheduleData,
            underwritingId: res[0] && res[0].success && Array.isArray(res[0].data) && res[0].data.length
                ? mergePropertySingletonRows(res[0].data).ARCIMEDES_ROW_ID
                : null
        }, () => {
            if (isSaved) this.props.parentSetData({ success: 'Saved' });
        });
    }

    setFieldsDisabled(data) {
        const newData = cloneDeep(data);

        stringProps.map(prop => {
            newData.tables[prop.table].rows[prop.tableKey].forceStatic = !prop.hasOwnProperty('forceStatic');
        });
        dateProps.map(prop => {
            newData.tables[prop.table].rows[prop.tableKey].forceStatic = !prop.hasOwnProperty('forceStatic');
        });
        numberProps.map(prop => {
            if (prop.hasOwnProperty('valueCellIndex')) {
                newData.tables[prop.table].rows[prop.tableKey].valueCells[prop.valueCellIndex].forceStatic = !prop.hasOwnProperty('forceStatic');
            } else {
                newData.tables[prop.table].rows[prop.tableKey].forceStatic = !prop.hasOwnProperty('forceStatic');
            }
        });

        Object.keys(newData.tables['rent-schedule'].rows).map(key => {
            newData.tables['rent-schedule'].rows[key].valueCells[0].forceStatic = true;
        });

        Object.keys(newData.tables['annualized-operating-data'].rows).map(key => {
            newData.tables['annualized-operating-data'].rows[key].valueCells[0].forceStatic = true;
        });

        return newData;
    }

    togglePopupMessage() {
        this.setState({ displayPopupSubmit: !this.state.displayPopupSubmit })
    }

    handleExpand(tableIdentifier) {
        const data = cloneDeep(this.state.data);
        data.tables[tableIdentifier].footerRow.forEach((e, index) => {
            if (index > 0) {
                e.valueCells.forEach(cell => {
                    if (cell) {
                        cell.hidden = !cell.hidden;
                    }
                });
            }
        })

        this.setState({
            data,
            isAdditionalPriceVisible: !this.state.isAdditionalPriceVisible,
        });
    }

    static changeVacantView(tables, leaseType) {
        const isVacantLeaseType = leaseType === 'Vacant';
        vacantChanges.map(prop => {
            if (prop.hasValueCells) {
                tables[prop.table].rows[prop.rowKey].valueCells.map(cell => {
                    cell[prop.property] = prop.getValue(isVacantLeaseType);
                });
            } else {
                tables[prop.table].rows[prop.rowKey][prop.property] = prop.getValue(isVacantLeaseType);
            }
        });
        return tables;
    }

    static changeLeaseView(tables, saleLeaseBack) {
        const isSaleLeaseBack = saleLeaseBack === 'Yes';
        leaseChanges.map(prop => {
            if (prop.hasValueCells) {
                tables[prop.table].rows[prop.rowKey].valueCells.map(cell => {
                    cell[prop.property] = prop.getValue(isSaleLeaseBack);
                });
            } else {
                tables[prop.table].rows[prop.rowKey][prop.property] = prop.getValue(isSaleLeaseBack);
            }
        });
        return tables;
    }

    onTableValueChange(tableIdentifier, rowCode, event, columnIndex, isFooter) {
        const data = cloneDeep(this.state.data);
        const value = event.currentTarget.value;
        if (isFooter) {
            data.tables[tableIdentifier].footerRow[rowCode].valueCells[columnIndex].value = value;
            if (tableIdentifier === "annualized-operating-data") {
                data.tables[tableIdentifier].footerRow[0].valueCells[2].getComputedValue(data.tables);
            }
        } else if (columnIndex === undefined || columnIndex === null) {
            if (tableIdentifier === 'lease-summary' && rowCode === 'lease-type' &&
                (data.tables[tableIdentifier].rows[rowCode].value !== 'Vacant' && value === 'Vacant' ||
                    data.tables[tableIdentifier].rows[rowCode].value === 'Vacant' && value !== 'Vacant')) {
                data.tables = UnderwritingSingleTenant.changeVacantView(data.tables, value);
            }
            if (tableIdentifier === 'general-information' && rowCode === 'sale-lease-back')
                data.tables = UnderwritingSingleTenant.changeLeaseView(data.tables, value);
            data.tables[tableIdentifier].rows[rowCode].value = value;
        } else {
            data.tables[tableIdentifier].rows[rowCode].valueCells[columnIndex].value = value;
        }


        if (tableIdentifier === 'pricing-rent-matrix' && rowCode === 'sqft') {
            data.tables['offering-summary'].rows['gross-leasable-area'].value = +value;
        }
        else if (tableIdentifier === 'offering-summary' && rowCode === 'gross-leasable-area') {
            data.tables['pricing-rent-matrix'].rows['sqft'].valueCells[0].value = value.toString();
        }

        if (tableIdentifier === 'pricing-matrix' && rowCode === 'price-psf-change') {
            data.tables['pricing-rent-matrix'].rows['rent-adjustment'].valueCells[0].value = value.toString();
        }
        else if (tableIdentifier === 'pricing-rent-matrix' && rowCode === 'rent-adjustment' && columnIndex !== 6) {
            data.tables['pricing-matrix'].rows['price-psf-change'].valueCells[0].value = value.toString();
        }

        if (tableIdentifier === 'offering-summary' && rowCode === 'cap-rate') {
            data.tables['pricing-rent-matrix'].rows['base-rent-psf'].valueCells[6].value = value.toString();
            const changedAnticipatedValue = (parseFloat(value) + parseFloat(data.tables['pricing-rent-matrix'].rows['rent-adjustment'].valueCells[6].value))
            const changedConservativeValue = (changedAnticipatedValue + (parseFloat(data.tables['pricing-rent-matrix'].rows['rent-adjustment'].valueCells[6].value)))
            data.tables['pricing-rent-matrix'].rows['price-percentages'].valueCells[3].value = value ? (parseFloat(value).toFixed(2) + "%") : ("-");
            data.tables['pricing-rent-matrix'].rows['price-percentages'].valueCells[4].value = isValidPriceChange(+changedAnticipatedValue);
            data.tables['pricing-rent-matrix'].rows['price-percentages'].valueCells[5].value = isValidPriceChange(+changedConservativeValue);

        }
        else if (tableIdentifier === 'pricing-rent-matrix' && rowCode === 'base-rent-psf' && columnIndex === 6) {
            data.tables['offering-summary'].rows['cap-rate'].value = +value;
            const changedAnticipatedValue = (parseFloat(value) + parseFloat(data.tables['pricing-rent-matrix'].rows['rent-adjustment'].valueCells[6].value))
            const changedConservativeValue = (changedAnticipatedValue + (parseFloat(data.tables['pricing-rent-matrix'].rows['rent-adjustment'].valueCells[6].value)))
            data.tables['pricing-rent-matrix'].rows['price-percentages'].valueCells[3].value = value ? (parseFloat(value).toFixed(2) + "%") : ("-");
            data.tables['pricing-rent-matrix'].rows['price-percentages'].valueCells[4].value = isValidPriceChange(+changedAnticipatedValue);
            data.tables['pricing-rent-matrix'].rows['price-percentages'].valueCells[5].value = isValidPriceChange(+changedConservativeValue);
        }

        if (tableIdentifier === 'pricing-matrix' && rowCode === 'bps-change') {
            data.tables['pricing-rent-matrix'].rows['rent-adjustment'].valueCells[6].value = value;
            const changedAnticipatedValue = (parseFloat(value) + parseFloat(data.tables['pricing-rent-matrix'].rows['base-rent-psf'].valueCells[6].value))
            const changedConservativeValue = (changedAnticipatedValue + parseFloat(value))
            data.tables['pricing-rent-matrix'].rows['price-percentages'].valueCells[4].value = isValidPriceChange(+changedAnticipatedValue);
            data.tables['pricing-rent-matrix'].rows['price-percentages'].valueCells[5].value = isValidPriceChange(+changedConservativeValue);
        }
        else if (tableIdentifier === 'pricing-rent-matrix' && rowCode === 'rent-adjustment' && columnIndex === 6) {
            data.tables['pricing-matrix'].rows['bps-change'].valueCells[0].value = value;
            const changedAnticipatedValue = (parseFloat(value) + parseFloat(data.tables['pricing-rent-matrix'].rows['base-rent-psf'].valueCells[6].value))
            const changedConservativeValue = (changedAnticipatedValue + parseFloat(value))
            data.tables['pricing-rent-matrix'].rows['price-percentages'].valueCells[4].value = isValidPriceChange(+changedAnticipatedValue);
            data.tables['pricing-rent-matrix'].rows['price-percentages'].valueCells[5].value = isValidPriceChange(+changedConservativeValue);

        }


        if (tableIdentifier === 'pricing-rent-matrix' && rowCode === 'base-rent-psf' && columnIndex !== 6) {
            data.tables['rent-schedule'].rows[0].valueCells[1].value = value
            data.tables['annualized-operating-data'].rows[0].valueCells[2].changedValue = value * (data.tables['offering-summary'].rows['gross-leasable-area'].value)
            let annualValue = data.tables['annualized-operating-data'].rows[0].valueCells[2].changedValue;
            let monthlyValue = annualValue / 12;
            //let formattedMonthlyValue = (monthlyValue % 1 === 0) ? monthlyValue.toFixed(0) : monthlyValue.toFixed(2);
            data.tables['rent-schedule'].rows[0].valueCells[0].value = monthlyValue.toFixed(2);
        }
        else if (tableIdentifier === "rent-schedule" && rowCode === "0") {
            data.tables['rent-schedule'].rows[0].valueCells[1].value = '';
            data.tables['annualized-operating-data'].rows[0].valueCells[2].changedValue = '';
            data.tables['pricing-rent-matrix'].rows['base-rent-psf'].valueCells[0].value = data.tables['rent-schedule'].rows[0].valueCells[1].getComputedValue(data.tables, 0).internalValue;
        }

        this.setState({ data: data });
    }

    onTableValueBlur(tableIdentifier, rowCode, event, columnIndex) {
        const data = cloneDeep(this.state.data);
        const value = event.currentTarget.value;




        if (tableIdentifier === 'annualized-operating-data' && columnIndex === currentYearsIndex) {
            data.tables = UnderwritingSingleTenant.calculateMonthlyRents(data.tables);
            data.tables = UnderwritingSingleTenant.calculateLeaseCommencement(data.tables, this.props.data.CLOSE_OF_ESCROW);
            this.setState({ data: data });
            return;
        }

        if (tableIdentifier === 'lease-summary' && rowCode === 'lease-commencement' ||
            tableIdentifier === 'lease-summary' && rowCode === 'lease-expiration') {
            data.tables = UnderwritingSingleTenant.calculateLeaseCommencement(data.tables, this.props.data.CLOSE_OF_ESCROW);
            this.setState({ data: data });
            return;
        }

        if (columnIndex === undefined || columnIndex === null)
            return;

        if (tableIdentifier === 'rent-schedule') {
            const val = value && !(/^[a-zA-Z]+$/g).test(value) ? parseFloat(value).toFixed(2) : value;
            data.tables[tableIdentifier].rows[rowCode].valueCells[columnIndex].value = val;
            // if the first 2 monthly rents exist, calculate the others
            if (columnIndex === monthlyRentIndex && val &&
                (rowCode === '0' && data.tables[tableIdentifier].rows[1].valueCells[columnIndex].value
                    || rowCode === '1' && data.tables[tableIdentifier].rows[0].valueCells[columnIndex].value))
                data.tables = UnderwritingSingleTenant.calculateMonthlyRents(data.tables);
        } else {
            const propIndex = findIndex(numberProps, { tableKey: rowCode });
            if (propIndex >= 0 && numberProps[propIndex].hasOwnProperty('withToFixed'))
                data.tables[tableIdentifier].rows[rowCode].valueCells[columnIndex].value = value ? parseFloat(value).toFixed(2) : '';
        }
        this.setState({ data: data });
    }

    addRow() {
        const data = cloneDeep(this.state.data);
        const newRowIndex = Object.keys(data.tables['annualized-operating-data'].rows).length;
        data.tables['annualized-operating-data'].rows[newRowIndex] = buildOperatingDataRow({});
        data.tables['rent-schedule'].rows[newRowIndex] = buildRentScheduleRow({});
        this.setState({ data });
    }

    deleteRow(rowIdentifier) {
        const data = cloneDeep(this.state.data);
        ['annualized-operating-data', 'rent-schedule'].map(tableId => {
            const rowsCount = Object.keys(data.tables[tableId].rows).length;
            if (rowsCount <= 1) {
                alert("You can't delete all the rows from the table!");
            } else {
                // move rows up and delete the last one
                for (let index = parseInt(rowIdentifier); index < rowsCount - 1; index++)
                    data.tables[tableId].rows[index] = data.tables[tableId].rows[index + 1];
                delete data.tables[tableId].rows[rowsCount - 1];
            }
        });
        this.setState({ data });
    }

    static renderNameCell(row, tableIdentifier = '', stateData = {}) {
        if (row.hidden) return;

        if (tableIdentifier && tableIdentifier === "offering-summary" && Object.keys(stateData).length &&
            stateData.data.tables['general-information'].rows['property-category'].value &&
            stateData.data.tables['general-information'].rows['property-category'].value !== 'industrial' &&
            row.industrySpecific) return;

        return (
            <td className='name-cell'>
                <span className='text'>{row.name}</span>
            </td>
        );
    }

    static renderStaticValueCell(tables, row, rowKey, domKey, closeOfEscrow, preComputedValues, printRentMatrix = false) {
        if (row.hidden) return;

        const displayValue = row.getComputedValue(tables, rowKey, closeOfEscrow, preComputedValues).displayValue;
        return (
            <td className={`${(displayValue === '-' ? 'center-dashes' : '')} ${!printRentMatrix ? 'value-cell' : 'value-cell-header'} ${(row.styleClasses && row.styleClasses.length ? row.styleClasses : '')}`}
                key={domKey}>
                <span className='text value'>{displayValue}</span>
                {row.tooltip ? <span className='cell-tooltip'>{row.tooltip}</span> : null}
            </td>
        );
    }

    static renderPricingCells(tables, row, rowKey, domKey, closeOfEscrow, preComputedValues) {
        if (row.hidden) return;

        const isconservative = domKey.includes("conservative")
        const displayValue = row.getComputedValue(tables, rowKey, closeOfEscrow, preComputedValues).displayValue;
        return (
            <tr>
                <td className={`${(displayValue === '-' ? 'center-dashes' : '')} ${!isconservative ? 'value-cell' : 'value-cell-conservative'} ${(row.styleClasses && row.styleClasses.length ? row.styleClasses : '')}`}
                    key={domKey}>
                    <span className='text value'>{displayValue}</span>
                    {row.tooltip ? <span className='cell-tooltip'>{row.tooltip}</span> : null}
                </td>
            </tr>

        );
    }



    renderEditableValueCell(tableIdentifier, rowKey, row, columnIndex, hasRowManipulation, isFooter) {
        if (row.hidden) return;

        if (tableIdentifier === "offering-summary" &&
            this.state.data.tables['general-information'].rows['property-category'].value &&
            this.state.data.tables['general-information'].rows['property-category'].value !== 'industrial' &&
            row.industrySpecific
        ) {
            return
        }

        const valueNeedsFormatting = row.valueNeedsFormatting || (row.type === 'number' && (row.unit === '$' || row.unit === '%' || row.unit === 'SF' || row.unit === 'Acres' || row.unit === 'Years' || row.unit === 'bps' || row.unit === 'Ft'));
        if (row.forceStatic) {
            return (
                <td className={`value-cell ${(row.styleClasses && row.styleClasses.length ? row.styleClasses : '')}`}
                    key={`${rowKey}-${columnIndex}`}>
                    {tableIdentifier === 'general-information' && rowKey === 'google-maps-link' && row.value ?
                        <a className='link' href={row.value} target='_blank'>{row.value}</a>
                        :
                        <span className='text value'>{row.value.toLocaleString()}</span>
                    }
                </td>
            )
        }

        return (
            <td className='value-cell editable-cell' key={`${rowKey}-${columnIndex}`}>
                {row.type === 'dropdown' ?
                    row.name === 'State' ?
                        <label>
                            <select
                                onChange={(event) => this.onTableValueChange(tableIdentifier, rowKey, event, columnIndex)}
                                value={row.value}>
                                <option value='' />
                                {row.dropdownValues ? row.dropdownValues.filter(el => !el.isTerritory).map(elem =>
                                    <option key={elem.hasOwnProperty('abbr') ? elem.abbr : elem} value={elem.hasOwnProperty('abbr') ? elem.abbr : elem}>{elem.hasOwnProperty('name') ? elem.name : elem}</option>) : null}
                            </select>
                        </label>
                        :
                        <label>
                            <select
                                onChange={(event) => this.onTableValueChange(tableIdentifier, rowKey, event, columnIndex)}
                                value={row.value}>
                                <option value='' />
                                {row.dropdownValues ? row.dropdownValues.map(elem =>
                                    <option key={elem.hasOwnProperty('code') ? elem.code : elem} value={elem.hasOwnProperty('code') ? elem.code : elem}>{elem.hasOwnProperty('name') ? elem.name : elem}</option>) : null}
                            </select>
                        </label>
                    :
                    hasRowManipulation ?
                        <div>
                            <label className={`${valueNeedsFormatting ? 'formatted-number-label' : ''} ${row.type}`}>
                                <input value={row.value}
                                    onChange={(event) => this.onTableValueChange(tableIdentifier, rowKey, event, columnIndex)}
                                    onBlur={(event) => this.onTableValueBlur(tableIdentifier, rowKey, event, columnIndex)}
                                    type={row.type !== 'date' ? row.type : null}
                                    placeholder={row.withoutPlaceholder ? '' : (row.type === 'date' ? 'MM/DD/YYYY' : row.unit)} />
                                <div className="input-display-value">
                                    {row.value && !(/^[a-zA-Z]+$/g).test(row.value) && row.unit === '$' ? row.unit : null}
                                    {row.value ?
                                        row.withDecimals ? Number(row.value).toFixed(2) : addCommasToNumber(row.value)
                                        : null}
                                    {row.value && row.unit !== '$' ? (row.unit === 'Acres' || row.unit === 'SF' || row.unit === 'Ft' ? ` ${row.unit}` : row.unit) : null}
                                </div>
                            </label>
                            <div className="more-button">
                                <div className="dot" />
                                <div className="dot" />
                                <div className="dot" />
                                <div className="row-manipulation-container">
                                    <div className="action-button" onClick={() => this.deleteRow(rowKey)}>Delete row</div>
                                    <div className="action-button" onClick={this.addRow}>Add row</div>
                                </div>
                            </div>
                        </div>
                        :
                        <label className={`${valueNeedsFormatting ? 'formatted-number-label' : ''} ${row.type}`}>
                            <input value={row.value}
                                onChange={(event) => this.onTableValueChange(tableIdentifier, rowKey, event, columnIndex, isFooter)}
                                onBlur={(event) => this.onTableValueBlur(tableIdentifier, rowKey, event, columnIndex)}
                                type={row.type !== 'date' ? row.type : null}
                                placeholder={row.withoutPlaceholder ? '' : (row.type === 'date' ? 'MM/DD/YYYY' : row.unit)} />
                            <div className="input-display-value">
                                {row.value && !(/^[a-zA-Z]+$/g).test(row.value) && row.unit === '$' ? row.unit : null}
                                {row.value ?
                                    row.withDecimals ? Number(row.value).toFixed(2) : addCommasToNumber(row.value)
                                    : null}
                                {row.value && row.unit !== '$' ? (['Acres', 'SF', 'Years', 'Ft'].includes(row.unit) ? ` ${row.unit}` : row.unit) : null}
                            </div>
                            {row.name === 'Address' ?
                                <a className="link-button"
                                    href={arc.path.base + 'map/' + this.props.data.ARCIMEDES_ROW_ID} target="_blank">
                                    <Icon svg={svgPlace} />
                                </a>
                                :
                                <a className="link-button" href={row.value} target="_blank">
                                    <svg aria-hidden="true" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
                                        <path fill="currentColor" d="M576 24v127.984c0 21.461-25.96 31.98-40.971 16.971l-35.707-35.709-243.523 243.523c-9.373 9.373-24.568 9.373-33.941 0l-22.627-22.627c-9.373-9.373-9.373-24.569 0-33.941L442.756 76.676l-35.703-35.705C391.982 25.9 402.656 0 424.024 0H552c13.255 0 24 10.745 24 24zM407.029 270.794l-16 16A23.999 23.999 0 0 0 384 303.765V448H64V128h264a24.003 24.003 0 0 0 16.97-7.029l16-16C376.089 89.851 365.381 64 344 64H48C21.49 64 0 85.49 0 112v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V287.764c0-21.382-25.852-32.09-40.971-16.97z" />
                                    </svg>
                                </a>
                            }
                        </label>
                }
            </td>
        );
    }

    renderTable(tables, tableIdentifier, closeOfEscrow) {
        const table = tables[tableIdentifier];

        const tableRows = Object.keys(table.rows).map(key => {
            const row = table.rows[key];
            const nameCell = UnderwritingSingleTenant.renderNameCell(row, tableIdentifier, this.state);
            let valueCell;

            if (row.editable) {
                valueCell = this.renderEditableValueCell(tableIdentifier, key, row);
            } else {
                valueCell = UnderwritingSingleTenant.renderStaticValueCell(tables, row, key, null, closeOfEscrow);
            }

            return (
                <tr key={key} className={key}>{nameCell}{valueCell}</tr>
            );
        });

        return (
            <table className={`Financials_table ${tableIdentifier}-table`} key={tableIdentifier}>
                <tbody>{tableRows}</tbody>
            </table>
        )
    }

    renderTable1(tables, tableIdentifier, closeOfEscrow) {
        const table = tables[tableIdentifier];

        const tableRows = Object.keys(table.rows).map(key => {
            const row = table.rows[key];
            const nameCell = UnderwritingSingleTenant.renderNameCell(row);
            let valueCell;

            if (row.editable) {
                valueCell = this.renderEditableValueCell(tableIdentifier, key, row);
            } else {
                valueCell = UnderwritingSingleTenant.renderStaticValueCell(tables, row, key, null, closeOfEscrow);
            }

            return (
                ['base-rent', 'rent-adjustment'].includes(row) ? <tr key={key} className={key}>{nameCell}{valueCell}</tr> : <tr key={key} className={key}>{valueCell}</tr>
            );
        });

        return (
            <table className={`Financials_table ${tableIdentifier}-table`} key={tableIdentifier}>
                <tbody>{tableRows}</tbody>
            </table>
        )
    }

    renderMatrixTable(tableIdentifier, preComputedValues) {
        const tables = this.state.data.tables;
        const table = tables[tableIdentifier];
        const isSaleLeaseBack = tables['general-information']['rows']['sale-lease-back'].value;
        if (tableIdentifier === 'annualized-operating-data' && isSaleLeaseBack != 'Yes' && (isSaleLeaseBack == 'No' || !isSaleLeaseBack)) {
            if (table.headerRow.indexOf('Commencement') < 0) {
                table.headerRow.splice(1, 0, "Commencement")
            }
        }
        else {
            const index = table.headerRow.indexOf('Commencement');
            if (index >= 0) {
                table.headerRow.splice(index, 1)
            }
        }
        const tableRows = Object.keys(table.rows).map((key) => {
            const row = table.rows[key];
            if (row.hidden) return;

            const nameCell = UnderwritingSingleTenant.renderNameCell(row);

            const rowContent = (
                <tr key={key} className={key}>
                    {table.hasNamesColumn ? nameCell : null}
                    {row.valueCells.map((cell, index) => {
                        if (cell === null) {
                            return <td key={index} className='invisible' />;
                        }
                        if (cell.editable) {
                            const hasRowManipulation = cell.hasRowManipulation;
                            return this.renderEditableValueCell(tableIdentifier, key, cell, index, hasRowManipulation);
                        } else {
                            const domKey = `${key}-${index}`;
                            return UnderwritingSingleTenant.renderStaticValueCell(tables, cell, key, domKey, preComputedValues);
                        }
                    })}
                </tr>
            );

            if (['rent-adjustment', 'conservative'].includes(key)) {
                return (
                    <React.Fragment key={key}>
                        {rowContent}
                        <tr style={{ height: key === "rent-adjustment" ? "25px" : "" }} />
                    </React.Fragment>
                );
            } else {
                return (
                    <React.Fragment key={key}>
                        {rowContent}
                    </React.Fragment>
                );
            }
        });

        return (
            <table className={`Financials_table ${tableIdentifier}-table`} key={tableIdentifier}>
                <tbody>
                    {table.headerRow && table.headerRow.length ?
                        <tr>{table.headerRow.map((cell) => {
                            return (
                                <td className='header-cell' key={cell}>
                                    <div className='text'>{cell}</div>
                                </td>
                            )
                        })}</tr>
                        : null
                    }

                    {tableRows}

                    {table.footerRow && Array.isArray(table.footerRow) ?
                        table.footerRow.map((row, index) => {
                            return (
                                <tr className='footer-row' key={index}>{Object.keys(row.valueCells).map((key) => {
                                    const cell = row.valueCells[key];
                                    if (cell && cell.hidden)
                                        return;

                                    if (cell && !cell.empty) {
                                        if (cell.hasExpandButton)
                                            return (
                                                <td className='invisible' key={key}>
                                                    <div className='expand-button' onClick={() => this.handleExpand(tableIdentifier)}>
                                                        <Icon svg={this.state.isAdditionalPriceVisible ? minusIcon : plusIcon} />
                                                    </div>
                                                </td>
                                            );

                                        if (cell.editable)
                                            return this.renderEditableValueCell(tableIdentifier, index, cell, key, null, true);

                                        const cellComputedValue = cell.getComputedValue(tables);
                                        return (
                                            <td key={key}>
                                                <div className={`text${cell.hasExpandButton ? ' with-expand' : ''}`}>
                                                    {cellComputedValue.hasOwnProperty('displayValue') ? cellComputedValue.displayValue : cellComputedValue}
                                                    {
                                                        cell.hasExpandButton &&
                                                        <div className='expand-button' onClick={() => this.handleExpand(tableIdentifier)}>
                                                            <Icon svg={plusIcon} />
                                                        </div>
                                                    }
                                                </div>
                                            </td>
                                        );
                                    }
                                    return <td className='invisible' key={key} />;
                                })}</tr>
                            )
                        })
                        :
                        table.footerRow && table.footerRow.valueCells && table.footerRow.valueCells.length ?
                            <tr className='footer-row'>{Object.keys(table.footerRow.valueCells).map((key) => {
                                const cell = table.footerRow.valueCells[key];
                                if (cell) {
                                    const cellComputedValue = cell.getComputedValue(tables);
                                    return (
                                        <td key={key}>
                                            <div className='text'>
                                                {cellComputedValue.hasOwnProperty('displayValue') ? cellComputedValue.displayValue : cellComputedValue}
                                            </div>
                                        </td>
                                    );
                                }
                                return <td className='invisible' key={key} />;
                            })}</tr>
                            : null
                    }
                </tbody>
            </table>
        )
    }

    renderPricingRentMatrix(tableIdentifier, preComputedValues) {
        const tables = this.state.data.tables;
        const table = tables[tableIdentifier];
        const isSaleLeaseBack = tables['general-information']['rows']['sale-lease-back'].value;
        if (tableIdentifier === 'annualized-operating-data' && isSaleLeaseBack != 'Yes' && (isSaleLeaseBack == 'No' || !isSaleLeaseBack)) {
            if (table.headerRow.indexOf('Commencement') < 0) {
                table.headerRow.splice(1, 0, "Commencement")
            }
        }
        else {
            const index = table.headerRow.indexOf('Commencement');
            if (index >= 0) {
                table.headerRow.splice(index, 1)
            }
        }
        const headerRowContent = (
            <tr>{table.mainRows.map((cell) => {
                return (
                    <td className='value-cell-header' style={{ fontWeight: "bold", backgroundColor: "#f7f7f7" }}>
                        <span className='text'>{cell}</span>
                    </td>
                )
            })}</tr>
        )

        const pricePercentageData = (
            <tr className='percentage-rows'>{table.rows['price-percentages'].valueCells.map((cell) => {
                return (
                    <td className='name-cell'>
                        <span className='text'>{cell.value}</span>
                    </td>
                )
            })}</tr>
        )
        const tableRows = Object.keys(table.rows).map((key) => {
            const row = table.rows[key];
            if (row.hidden) return;

            const nameCell = UnderwritingSingleTenant.renderNameCell(row);

            if (row.displayName && row.name !== 'Sq Ft') {

                const rowContent = (
                    <tr key={key} className={key}>
                        {row.displayName ? nameCell : null}
                        {row.valueCells.map((cell, index) => {
                            if (cell === null) {
                                return <td key={index} className='invisible' />;
                            }
                            if (cell.editable) {
                                const hasRowManipulation = cell.hasRowManipulation;
                                return this.renderEditableValueCell(tableIdentifier, key, cell, index, hasRowManipulation);
                            } else {
                                const domKey = `${key}-${index}`;
                                return UnderwritingSingleTenant.renderStaticValueCell(tables, cell, key, domKey, preComputedValues, '', true);
                            }
                        })}
                    </tr>

                );


                if (['rent-adjustment', 'conservative'].includes(key)) {
                    return (
                        <React.Fragment key={key}>
                            {rowContent}
                            <tr style={{ height: key === "rent-adjustment" ? "25px" : "" }} />
                        </React.Fragment>
                    );
                } else {
                    return (
                        <React.Fragment key={key}>
                            {rowContent}
                        </React.Fragment>
                    );
                }
            }
            return ""

        });

        const footerRows = Object.keys(table.rows).map((key) => {
            const row = table.rows[key];
            if (row.displayName && row.name === 'Sq Ft') {
                const rowContent = (
                    <tr key={key} className={key}>
                        <td className='pricing-footer'>
                            <span className='text'>{row.name}</span>
                        </td>
                        {row.valueCells.map((cell, index) => {
                            const hasRowManipulation = cell.hasRowManipulation;
                            return this.renderEditableValueCell(tableIdentifier, key, cell, index, hasRowManipulation);
                        })}
                    </tr>

                );
                return (
                    <React.Fragment key={key}>
                        {rowContent}
                    </React.Fragment>
                );
            }
        });

        const contentTableRows = Object.keys(table.rows).map((key) => {
            const row = table.rows[key];
            if (row.hidden) return;

            const nameCell = UnderwritingSingleTenant.renderNameCell(row);
            if (row.displayName) {
                return;
            }

            const rowContent = (
                <table className='content-table-data'>
                    <tr key={key} className={key}>
                        {row.displayName ? nameCell : null}
                        {row.valueCells.map((cell, index) => {
                            if (cell === null) {
                                return <td key={index} className='invisible' />;
                            }
                            if (cell.editable) {
                                const hasRowManipulation = cell.hasRowManipulation;
                                return this.renderEditableValueCell(tableIdentifier, key, cell, index, hasRowManipulation);
                            } else {
                                const domKey = `${key}-${index}`;
                                return UnderwritingSingleTenant.renderPricingCells(tables, cell, key, domKey, preComputedValues);
                            }
                        })}
                    </tr>
                </table>

            );


            if (['rent-adjustment', 'conservative'].includes(key)) {
                return (
                    <React.Fragment key={key}>
                        {rowContent}
                        <tr style={{ height: key === "rent-adjustment" ? "25px" : "" }} />
                    </React.Fragment>
                );
            } else {
                return (
                    <React.Fragment key={key}>
                        {rowContent}
                    </React.Fragment>
                );
            }
        });

        return (
            <table className={`Financials_table ${tableIdentifier}-table`} key={tableIdentifier}>
                <tbody>
                    {table.headerRow && table.headerRow.length ?
                        <tr>{table.headerRow.map((cell) => {
                            return (
                                <td className='header-cell' key={cell}>
                                    <div className='text'>{cell}</div>
                                </td>
                            )
                        })}</tr>
                        : null
                    }
                    <React.Fragment>
                        {tableRows}
                        <div className='headers-content'>
                            {pricePercentageData}
                            {headerRowContent}
                        </div>
                        <span className='table-content' style={{ display: "flex" }}>
                            {contentTableRows}
                        </span>
                        <div className="footer-content" style={{ marginTop: "10px" }}>
                            {footerRows}
                        </div>
                    </React.Fragment>


                    {table.footerRow && Array.isArray(table.footerRow) ?
                        table.footerRow.map((row, index) => {
                            return (
                                <tr className='footer-row' key={index}>{Object.keys(row.valueCells).map((key) => {
                                    const cell = row.valueCells[key];
                                    if (cell && cell.hidden)
                                        return;

                                    if (cell && !cell.empty) {
                                        if (cell.hasExpandButton)
                                            return (
                                                <td className='invisible' key={key}>
                                                    <div className='expand-button' onClick={() => this.handleExpand(tableIdentifier)}>
                                                        <Icon svg={this.state.isAdditionalPriceVisible ? minusIcon : plusIcon} />
                                                    </div>
                                                </td>
                                            );

                                        if (cell.editable)
                                            return this.renderEditableValueCell(tableIdentifier, index, cell, key, null, true);

                                        const cellComputedValue = cell.getComputedValue(tables);
                                        return (
                                            <td key={key}>
                                                <div className={`text${cell.hasExpandButton ? ' with-expand' : ''}`}>
                                                    {cellComputedValue.hasOwnProperty('displayValue') ? cellComputedValue.displayValue : cellComputedValue}
                                                    {
                                                        cell.hasExpandButton &&
                                                        <div className='expand-button' onClick={() => this.handleExpand(tableIdentifier)}>
                                                            <Icon svg={plusIcon} />
                                                        </div>
                                                    }
                                                </div>
                                            </td>
                                        );
                                    }
                                    return <td className='invisible' key={key} />;
                                })}</tr>
                            )
                        })
                        :
                        table.footerRow && table.footerRow.valueCells && table.footerRow.valueCells.length ?
                            <tr className='footer-row'>{Object.keys(table.footerRow.valueCells).map((key) => {
                                const cell = table.footerRow.valueCells[key];
                                if (cell) {
                                    const cellComputedValue = cell.getComputedValue(tables);
                                    return (
                                        <td key={key}>
                                            <div className='text'>
                                                {cellComputedValue.hasOwnProperty('displayValue') ? cellComputedValue.displayValue : cellComputedValue}
                                            </div>
                                        </td>
                                    );
                                }
                                return <td className='invisible' key={key} />;
                            })}</tr>
                            : null
                    }
                </tbody>
            </table>
        )
    }





    static renderTableContainer(tables, tableIdentifier, tablesToDisplay, isSaleLeaseBack = false) {
        const table = tables[tableIdentifier];

        const extraPading = (tableIdentifier && tableIdentifier === "pricing-matrix-annex" &&
            tables['general-information'].rows['property-category'].value &&
            tables['general-information'].rows['property-category'].value === 'industrial' &&
            tables['offering-summary'].rows['office-to-warehouse'].industrySpecific) ? "extra-padding-bottom" : "";
        return (
            <div className={`Financials_table_container ${tableIdentifier}-table-container ${extraPading}`} style={{ paddingBottom: isSaleLeaseBack ? "7.5rem" : "" }}>
                <h3 className='Financials_table_title'>{table.name}
                    <span className='Financials_table_description'>{table.description}</span>
                </h3>

                {tablesToDisplay.map(table => table)}
            </div>
        )
    }

    parseSingleTenantNumberValue(value, prop) {
        if (value === '' || value === null || value === undefined) {
            return null;
        }
        const raw = prop.withReplace ? String(value).replace(/,/g, '') : String(value);
        const parsed = parseFloat(raw);
        return Number.isNaN(parsed) ? null : parsed;
    }

    appendUnderwritingSingletonFieldsToPayload(tables, underwritingData) {
        stringProps.filter(prop => !prop.fromProps).forEach(prop => {
            if (underwritingData[prop.key] !== undefined) {
                return;
            }
            const value = tables[prop.table].rows[prop.tableKey].value;
            if (value) {
                underwritingData[prop.key] = value;
            }
        });

        dateProps.filter(prop => !prop.fromProps).forEach(prop => {
            if (underwritingData[prop.key] !== undefined) {
                return;
            }
            const value = tables[prop.table].rows[prop.tableKey].value;
            if (!value) {
                return;
            }
            const isoValue = stringUStoISO(value);
            if (isoValue) {
                underwritingData[prop.key] = isoValue;
            }
        });

        numberProps.filter(prop => !prop.fromProps && prop.table !== 'pricing-rent-matrix').forEach(prop => {
            if (underwritingData[prop.key] !== undefined) {
                return;
            }
            let value;
            if (prop.hasOwnProperty('valueCellIndex')) {
                value = tables[prop.table].rows[prop.tableKey].valueCells[prop.valueCellIndex].value;
            } else {
                value = tables[prop.table].rows[prop.tableKey].value;
            }
            const parsed = this.parseSingleTenantNumberValue(value, prop);
            if (parsed !== null) {
                underwritingData[prop.key] = parsed;
            }
        });
    }

    onSubmit() {
        const tables = this.state.data.tables;
        const originalTables = this.state.original.tables;
        const rentScheduleData = this.state.rentScheduleData;
        const propsData = cloneDeep(this.props.data);
        const propertyId = this.props.data.ARCIMEDES_ROW_ID;
        const underwritingData = {};

        if (originalTables['lease-summary'].rows['lease-type'].value == "Vacant" && tables['lease-summary'].rows['lease-type'].value != "Vacant") {
            tables['offering-summary'].rows['price-psf'].value = '';
        }

        if (tables['lease-summary'].rows['lease-type'].value == "Vacant") {
            // Clear Years and Commencement fileds
            Object.entries(tables['annualized-operating-data'].rows).forEach(([key, value]) => {
                tables['annualized-operating-data'].rows[key]['valueCells'][0].value = ''
                tables['annualized-operating-data'].rows[key]['valueCells'][1].value = ''
                tables['annualized-operating-data'].rows[key]['valueCells'][2].value = ''
            });

            Object.entries(tables['rent-schedule'].rows).forEach(([key, value]) => {
                tables['rent-schedule'].rows[key]['valueCells'][0].value = ''
                tables['rent-schedule'].rows[key]['valueCells'][1].value = ''
                tables['rent-schedule'].rows[key]['valueCells'][2].value = ''
            });

            Object.entries(tables['pricing-matrix'].rows).forEach(([key, value]) => {
                if (key == 'bps-change')
                    tables['pricing-matrix'].rows[key]['valueCells'][0].value = 0.0;

            });


            tables['offering-summary'].rows['cap-rate'].value = ''
            tables['lease-summary'].rows['guarantor'].value = ''
            tables['lease-summary'].rows['increases'].value = ''
            tables['lease-summary'].rows['lease-commencement'].value = ''
            tables['lease-summary'].rows['lease-expiration'].value = ''
            tables['lease-summary'].rows['options'].value = ''
            tables['lease-summary'].rows['options-to-purchase'].value = ''
            tables['general-information'].rows['sale-lease-back'].value = 'No'




        }

        if (tables['general-information'].rows['property-category'].value !== 'industrial') {
            tables['offering-summary'].rows['doors'].value = '';
            tables['offering-summary'].rows['clear-height'].value = '';
            tables['offering-summary'].rows['office-to-warehouse'].value = '';
        }

        stringProps.map(prop => {
            if (prop.hasOwnProperty('fromProps')) {
                // set property props
                propsData[prop.key] = tables[prop.table].rows[prop.tableKey].value;

            } else {
                // set underwritingData just if the value has been changed
                if (tables[prop.table].rows[prop.tableKey].value !== originalTables[prop.table].rows[prop.tableKey].value) {
                    underwritingData[prop.key] = tables[prop.table].rows[prop.tableKey].value;
                }
            }
        });

        dateProps.map(prop => {
            if (prop.hasOwnProperty('fromProps')) {
                // set property props
                propsData[prop.key] = tables[prop.table].rows[prop.tableKey].value;
            } else {
                const isoValue = tables[prop.table].rows[prop.tableKey].value
                    ? stringUStoISO(tables[prop.table].rows[prop.tableKey].value)
                    : null;
                const origIso = originalTables[prop.table].rows[prop.tableKey].value
                    ? stringUStoISO(originalTables[prop.table].rows[prop.tableKey].value)
                    : null;
                if (isoValue !== origIso) {
                    underwritingData[prop.key] = isoValue;
                }
            }
        });

        numberProps.map(prop => {
            if (prop.table !== 'pricing-rent-matrix') {
                if (prop.hasOwnProperty('fromProps')) {
                    // set property props
                    if (prop.withReplace) {
                        propsData[prop.key] = addCommasToNumber(tables[prop.table].rows[prop.tableKey].value);
                        return;
                    }
                    propsData[prop.key] = tables[prop.table].rows[prop.tableKey].value.toString();
                } else {
                    if (prop.hasOwnProperty('valueCellIndex')) {
                        const defaultValue = prop.defaultValue || '';
                        if (tables[prop.table].rows[prop.tableKey].valueCells[prop.valueCellIndex].value !== originalTables[prop.table].rows[prop.tableKey].valueCells[prop.valueCellIndex].value ||
                            prop.hasOwnProperty('defaultValue') && !tables[prop.table].rows[prop.tableKey].valueCells[prop.valueCellIndex].value) {
                            underwritingData[prop.key] = parseFloat(tables[prop.table].rows[prop.tableKey].valueCells[prop.valueCellIndex].value) || defaultValue;
                        }
                    } else {
                        if (tables[prop.table].rows[prop.tableKey].value !== originalTables[prop.table].rows[prop.tableKey].value) {
                            underwritingData[prop.key] = parseFloat(tables[prop.table].rows[prop.tableKey].value) || '';
                        }
                    }
                }
            }
        });

        tables['annualized-operating-data'].footerRow.forEach((e, index) => {
            if (index > 0) {
                const obj = {};
                let _index = index > 1 ? index : '';
                if (e.valueCells[0].value !== originalTables['annualized-operating-data'].footerRow[index].valueCells[0].value)
                    underwritingData['ADDITION_TYPE' + _index] = e.valueCells[0].value;
                if (e.valueCells[2].value !== originalTables['annualized-operating-data'].footerRow[index].valueCells[2].value)
                    underwritingData['ADDITION_VALUE' + _index] = e.valueCells[2].value;
            }
        });
        const noi = tables['offering-summary'].rows['net-operating-income'].getComputedValue(tables).internalValue;
        if (noi) {
            propsData.NET_OPERATING_INCOME = addCommasToNumber(noi);
            propsData.BASE_RENT = propsData.NET_OPERATING_INCOME;
        }

        const price = tables['offering-summary'].rows['price'].getComputedValue(tables).internalValue;
        if (price) {
            propsData.LIST_PRICE = addCommasToNumber(price);
        }

        const sale_lease_back = tables['general-information'].rows['sale-lease-back'].value
        if (sale_lease_back) {
            propsData.SALE_LEASE_BACK = sale_lease_back;
        }

        const rentSchedule = tables['rent-schedule'].rows;
        const annualizedOperatingData = tables['annualized-operating-data'].rows;
        const newRentScheduleData = [];
        const deletedRows = rentScheduleData ? cloneDeep(rentScheduleData) : [];
        const arcRowIdIndex = annualizedOperatingData[0].valueCells.length - 1;

        Object.keys(rentSchedule).forEach(key => {
            const rentObj = {};
            const rowId = annualizedOperatingData[key].valueCells[arcRowIdIndex].value;

            // remove existing rows in order to have only deleted ones
            if (rowId) {
                const index = findIndex(deletedRows, { ARCIMEDES_ROW_ID: rowId });
                if (index > -1)
                    deletedRows.splice(index, 1);
            }

            if ((originalTables['rent-schedule'].rows[key] &&
                rentSchedule[key].valueCells[monthlyRentIndex].value !== originalTables['rent-schedule'].rows[key].valueCells[monthlyRentIndex].value) ||
                !originalTables['rent-schedule'].rows[key]) {
                rentObj.MONTHLY_RENT = rentSchedule[key].valueCells[monthlyRentIndex].value;
            }
            if ((originalTables['annualized-operating-data'].rows[key] &&
                annualizedOperatingData[key].valueCells[currentYearsIndex].value !== originalTables['annualized-operating-data'].rows[key].valueCells[currentYearsIndex].value) ||
                !originalTables['annualized-operating-data'].rows[key]) {
                rentObj.YEARS = annualizedOperatingData[key].valueCells[currentYearsIndex].value;
            }
            if ((originalTables['annualized-operating-data'].rows[key] &&
                annualizedOperatingData[key].valueCells[leaseCommencementIndex].value !== originalTables['annualized-operating-data'].rows[key].valueCells[leaseCommencementIndex].value) ||
                !originalTables['annualized-operating-data'].rows[key]) {
                rentObj.LEASE_COMMENCEMENT = annualizedOperatingData[key].valueCells[leaseCommencementIndex].value ? stringUStoISO(annualizedOperatingData[key].valueCells[leaseCommencementIndex].value) : '';
            }

            // Set only if there was at least a change and the property exists
            if (Object.keys(rentObj).length && propertyId) {
                rentObj.PROPERTY_ID = propertyId;
                if (rowId)
                    rentObj.ARCIMEDES_ROW_ID = rowId;
                newRentScheduleData.push(rentObj);
            }
        });

        deletedRows.map(row => {
            newRentScheduleData.push({
                ARCIMEDES_ROW_ID: row.ARCIMEDES_ROW_ID,
                DELETED: 1,
            });
        });

        if (!propertyId)
            propsData.ARCIMEDES_ROW_ID = this.props.newPropertyId;

        // Sync underwriting fields back to property
        const cadLinkValue = tables['general-information'].rows['google-maps-link'].value;
        const originalCadLinkValue = originalTables['general-information'].rows['google-maps-link'].value;
        if (cadLinkValue !== originalCadLinkValue) {
            propsData.CAD_SITE = cadLinkValue || '';
        }

        // Sent back the property props
        this.setState({ newData: propsData });
        const copypropsData = { ...propsData }
        if (copypropsData.LOT_SIZE !== undefined) {
            copypropsData.ACRES = copypropsData.LOT_SIZE;
        }
        delete copypropsData.LOT_SIZE;
        //update sqft data in the rent and pricing range 

        const RentSqft = Number(tables['pricing-rent-matrix'].rows['sqft'].valueCells[0].value);
        const offeringSummarySqft = Number(originalTables['offering-summary'].rows['gross-leasable-area'].value);
        const originalSqft = Number((copypropsData.SQFT || '').replace(/,/g, ""))


        if ((offeringSummarySqft === originalSqft) && (originalSqft !== RentSqft)) {
            copypropsData.SQFT = RentSqft.toLocaleString();
            tables['offering-summary'].rows['gross-leasable-area'].value = RentSqft
        }

        this.props.parentSetData({ newData: copypropsData });

        this.appendUnderwritingSingletonFieldsToPayload(tables, underwritingData);

        const noChangesDetected = !Object.keys(underwritingData).length && newRentScheduleData.length < 1;
        if (Object.keys(underwritingData).length) {
            underwritingData.PROPERTY_ID = propertyId ? propertyId : this.props.newPropertyId;
            if (this.state.underwritingId) {
                underwritingData.ARCIMEDES_ROW_ID = this.state.underwritingId;
            }
        }

        // No changes detected for Underwriting, nothing to do
        if (noChangesDetected) {
            this.setState({ isBusy: false });
            this.props.parentSetData({ success: 'No data to update' });
            return;
        }

        Promise.all([
            request(arc.path.api, {
                service: 'arcimedes',
                action: 'open.datasource.table.Data.updateByTableCode',
                params: [UNDERWRITING_SINGLE_TENANT, {
                    value: [underwritingData],
                }]
            }),
            request(arc.path.api, {
                service: 'arcimedes',
                action: 'open.datasource.table.Data.updateByTableCode',
                params: [UNDERWRITING_RENT_SCHEDULE, {
                    value: newRentScheduleData,
                }]
            }),
        ]).then(res => {
            if (!res || !res[0] || (!res[0].success && Object.keys(underwritingData).length) ||
                !res[1] || (!res[1].success && newRentScheduleData.length)) {
                this.setState({ isBusy: false });
                this.props.parentSetData({ error: res && res[0] && res[0].message ? res[0].message : 'Unidentified Error' });
                return;
            }
            const underwritingId = res[0] && res[0].success && res[0].data && res[0].data[0]
                ? res[0].data[0].ARCIMEDES_ROW_ID || this.state.underwritingId
                : this.state.underwritingId;
            this.setState({ isBusy: false, underwritingId });
            this.getUnderwritingData(true);
        });
    }
    onConfirm() {
        this.setState({ isDialogueOpen: false });
        this.onSubmit()
    }
    onCancel() {
        this.setState({ isDialogueOpen: false, isBusy: false });
    }
    async beforeSubmit() {
        if (this.state.isBusy) return;
        this.setState({ isBusy: true });

        if (!(["Active", "In Negotiation", "Under Contract"].includes(this.props.data.STATUS) && this.props.data.SOURCE === "SUMMIT")) {
            this.onSubmit();
            return;
        }

        const tables = this.state.data.tables;
        const originalTables = this.state.original.tables;
        const rentScheduleData = this.state.rentScheduleData;
        const propsData = cloneDeep(this.props.data);
        const propertyId = this.props.data.ARCIMEDES_ROW_ID;
        const underwritingData = {};
        let changesInPropData = false;

        if (originalTables['lease-summary'].rows['lease-type'].value == "Vacant" && tables['lease-summary'].rows['lease-type'].value != "Vacant") {
            tables['offering-summary'].rows['price-psf'].value = '';
        }

        if (tables['lease-summary'].rows['lease-type'].value == "Vacant") {
            // Clear Years and Commencement fileds
            Object.entries(tables['annualized-operating-data'].rows).forEach(([key, value]) => {
                tables['annualized-operating-data'].rows[key]['valueCells'][0].value = ''
                tables['annualized-operating-data'].rows[key]['valueCells'][1].value = ''
                tables['annualized-operating-data'].rows[key]['valueCells'][2].value = ''
            });

            Object.entries(tables['rent-schedule'].rows).forEach(([key, value]) => {
                tables['rent-schedule'].rows[key]['valueCells'][0].value = ''
                tables['rent-schedule'].rows[key]['valueCells'][1].value = ''
                tables['rent-schedule'].rows[key]['valueCells'][2].value = ''
            });

            Object.entries(tables['pricing-matrix'].rows).forEach(([key, value]) => {
                if (key == 'bps-change')
                    tables['pricing-matrix'].rows[key]['valueCells'][0].value = 0.0;

            });


            tables['offering-summary'].rows['cap-rate'].value = ''
            tables['lease-summary'].rows['guarantor'].value = ''
            tables['lease-summary'].rows['increases'].value = ''
            tables['lease-summary'].rows['lease-commencement'].value = ''
            tables['lease-summary'].rows['lease-expiration'].value = ''
            tables['lease-summary'].rows['options'].value = ''
            tables['lease-summary'].rows['options-to-purchase'].value = ''
            tables['general-information'].rows['sale-lease-back'].value = 'No'




        }

        if (tables['general-information'].rows['property-category'].value !== 'industrial') {
            tables['offering-summary'].rows['doors'].value = '';
            tables['offering-summary'].rows['clear-height'].value = '';
            tables['offering-summary'].rows['office-to-warehouse'].value = '';
        }

        stringProps.map(prop => {
            if (prop.hasOwnProperty('fromProps')) {
                // set property props
                propsData[prop.key] = tables[prop.table].rows[prop.tableKey].value;
                changesInPropData = true;

            } else {
                // set underwritingData just if the value has been changed
                if (tables[prop.table].rows[prop.tableKey].value !== originalTables[prop.table].rows[prop.tableKey].value) {
                    underwritingData[prop.key] = tables[prop.table].rows[prop.tableKey].value;
                }
            }
        });

        dateProps.map(prop => {
            if (prop.hasOwnProperty('fromProps')) {
                // set property props
                propsData[prop.key] = tables[prop.table].rows[prop.tableKey].value;
            } else {
                const isoValue = tables[prop.table].rows[prop.tableKey].value
                    ? stringUStoISO(tables[prop.table].rows[prop.tableKey].value)
                    : null;
                const origIso = originalTables[prop.table].rows[prop.tableKey].value
                    ? stringUStoISO(originalTables[prop.table].rows[prop.tableKey].value)
                    : null;
                if (isoValue !== origIso) {
                    underwritingData[prop.key] = isoValue;
                }
            }
        });

        numberProps.map(prop => {
            if (prop.table !== 'pricing-rent-matrix') {
                if (prop.hasOwnProperty('fromProps')) {
                    // set property props
                    if (prop.withReplace) {
                        propsData[prop.key] = addCommasToNumber(tables[prop.table].rows[prop.tableKey].value);
                        return;
                    }
                    propsData[prop.key] = tables[prop.table].rows[prop.tableKey].value.toString();
                    changesInPropData = true;
                } else {
                    if (prop.hasOwnProperty('valueCellIndex')) {
                        const defaultValue = prop.defaultValue || '';
                        if (tables[prop.table].rows[prop.tableKey].valueCells[prop.valueCellIndex].value !== originalTables[prop.table].rows[prop.tableKey].valueCells[prop.valueCellIndex].value ||
                            prop.hasOwnProperty('defaultValue') && !tables[prop.table].rows[prop.tableKey].valueCells[prop.valueCellIndex].value) {
                            underwritingData[prop.key] = parseFloat(tables[prop.table].rows[prop.tableKey].valueCells[prop.valueCellIndex].value) || defaultValue;
                        }
                    } else {
                        if (tables[prop.table].rows[prop.tableKey].value !== originalTables[prop.table].rows[prop.tableKey].value) {
                            underwritingData[prop.key] = parseFloat(tables[prop.table].rows[prop.tableKey].value) || '';
                            propsData[prop.key] = tables[prop.table].rows[prop.tableKey].value.toString();
                        }
                    }
                }
            }
        });

        tables['annualized-operating-data'].footerRow.forEach((e, index) => {
            if (index > 0) {
                const obj = {};
                let _index = index > 1 ? index : '';
                if (e.valueCells[0].value !== originalTables['annualized-operating-data'].footerRow[index].valueCells[0].value)
                    underwritingData['ADDITION_TYPE' + _index] = e.valueCells[0].value;
                if (e.valueCells[2].value !== originalTables['annualized-operating-data'].footerRow[index].valueCells[2].value)
                    underwritingData['ADDITION_VALUE' + _index] = e.valueCells[2].value;
            }
        });
        const noi = tables['offering-summary'].rows['net-operating-income'].getComputedValue(tables).internalValue;
        if (noi) {
            propsData.NET_OPERATING_INCOME = addCommasToNumber(noi);
            propsData.BASE_RENT = propsData.NET_OPERATING_INCOME;
            changesInPropData = true;
        }

        const price = tables['offering-summary'].rows['price'].getComputedValue(tables).internalValue;
        if (price) {
            propsData.LIST_PRICE = addCommasToNumber(price);
            changesInPropData = true;
        }

        const sale_lease_back = tables['general-information'].rows['sale-lease-back'].value
        if (sale_lease_back) {
            propsData.SALE_LEASE_BACK = sale_lease_back;
            changesInPropData = true;
        }

        const rentSchedule = tables['rent-schedule'].rows;
        const annualizedOperatingData = tables['annualized-operating-data'].rows;
        const newRentScheduleData = [];
        const deletedRows = rentScheduleData ? cloneDeep(rentScheduleData) : [];
        const arcRowIdIndex = annualizedOperatingData[0].valueCells.length - 1;

        Object.keys(rentSchedule).forEach(key => {
            const rentObj = {};
            const rowId = annualizedOperatingData[key].valueCells[arcRowIdIndex].value;

            // remove existing rows in order to have only deleted ones
            if (rowId) {
                const index = findIndex(deletedRows, { ARCIMEDES_ROW_ID: rowId });
                if (index > -1)
                    deletedRows.splice(index, 1);
            }

            if ((originalTables['rent-schedule'].rows[key] &&
                rentSchedule[key].valueCells[monthlyRentIndex].value !== originalTables['rent-schedule'].rows[key].valueCells[monthlyRentIndex].value) ||
                !originalTables['rent-schedule'].rows[key]) {
                rentObj.MONTHLY_RENT = rentSchedule[key].valueCells[monthlyRentIndex].value;
            }
            if ((originalTables['annualized-operating-data'].rows[key] &&
                annualizedOperatingData[key].valueCells[currentYearsIndex].value !== originalTables['annualized-operating-data'].rows[key].valueCells[currentYearsIndex].value) ||
                !originalTables['annualized-operating-data'].rows[key]) {
                rentObj.YEARS = annualizedOperatingData[key].valueCells[currentYearsIndex].value;
            }
            if ((originalTables['annualized-operating-data'].rows[key] &&
                annualizedOperatingData[key].valueCells[leaseCommencementIndex].value !== originalTables['annualized-operating-data'].rows[key].valueCells[leaseCommencementIndex].value) ||
                !originalTables['annualized-operating-data'].rows[key]) {
                rentObj.LEASE_COMMENCEMENT = annualizedOperatingData[key].valueCells[leaseCommencementIndex].value ? stringUStoISO(annualizedOperatingData[key].valueCells[leaseCommencementIndex].value) : '';
            }

            // Set only if there was at least a change and the property exists
            if (Object.keys(rentObj).length && propertyId) {
                rentObj.PROPERTY_ID = propertyId;
                if (rowId)
                    rentObj.ARCIMEDES_ROW_ID = rowId;
                newRentScheduleData.push(rentObj);
            }
        });

        deletedRows.map(row => {
            newRentScheduleData.push({
                ARCIMEDES_ROW_ID: row.ARCIMEDES_ROW_ID,
                DELETED: 1,
            });
        });

        if (!propertyId)
            propsData.ARCIMEDES_ROW_ID = this.props.newPropertyId;

        // Sync underwriting fields back to property
        const cadLinkValue2 = tables['general-information'].rows['google-maps-link'].value;
        const originalCadLinkValue2 = originalTables['general-information'].rows['google-maps-link'].value;
        if (cadLinkValue2 !== originalCadLinkValue2) {
            propsData.CAD_SITE = cadLinkValue2 || '';
        }

        // Sent back the property props
        this.setState({ newData: propsData });
        const copypropsData = { ...propsData }
        if (copypropsData.LOT_SIZE !== undefined) {
            copypropsData.ACRES = copypropsData.LOT_SIZE;
        }
        delete copypropsData.LOT_SIZE;
        //update sqft data in the rent and pricing range 

        const RentSqft = Number(tables['pricing-rent-matrix'].rows['sqft'].valueCells[0].value);
        const offeringSummarySqft = Number(originalTables['offering-summary'].rows['gross-leasable-area'].value);
        const originalSqft = Number((copypropsData.SQFT || '').replace(/,/g, ""))


        if ((offeringSummarySqft === originalSqft) && (originalSqft !== RentSqft)) {
            copypropsData.SQFT = RentSqft.toLocaleString();
            tables['offering-summary'].rows['gross-leasable-area'].value = RentSqft
        }

        this.appendUnderwritingSingletonFieldsToPayload(tables, underwritingData);

        const noChangesDetected = !Object.keys(underwritingData).length && newRentScheduleData.length < 1 && !changesInPropData;
        if (Object.keys(underwritingData).length)
            underwritingData.PROPERTY_ID = propertyId ? propertyId : this.props.newPropertyId;

        // No changes detected for Underwriting, nothing to do
        if (noChangesDetected) {
            this.setState({ isBusy: false });
            this.props.parentSetData({ success: 'No data to update' });
            return;
        }

        if (tables['offering-summary'].rows['price'].getComputedValue(tables).internalValue !== originalTables['offering-summary'].rows['price'].getComputedValue(originalTables).internalValue) {
            this.setState({ isDialogueOpen: true, dialogTitle: 'Do you have an Amendment to the Rep Agreement to change the price?' });
        } else {
            this.setState({ isDialogueOpen: true, dialogTitle: 'Are you sure you want to save this financial data?' });
        }

    }

    getStaticImages(type) {
        const seq = (this._staticImagesSeq = (this._staticImagesSeq || 0) + 1);
        this.setState({ staticImagesLoading: true });
        return getData({
            tableCode: PRICING_ANALYSIS,
            options: {
                filterType: 'and',
                filter: [{
                    text: type,
                    code: 'PRODUCT_TYPE',
                    type: 'exact',
                }]
            },
        }).then((res) => {
            if (seq !== this._staticImagesSeq) return;
            if (res && res.success && res.data && res.data.length) {
                try {
                    const items = preProcess(res.data[0].ITEMS);
                    this.setState({ staticImages: items, staticImagesLoaded: true, staticImagesLoading: false });
                    return items;
                } catch (e) {
                    this.setState({ staticImages: [], staticImagesLoaded: true, staticImagesLoading: false });
                }
            } else {
                this.setState({ staticImages: [], staticImagesLoaded: true, staticImagesLoading: false });
            }
        }).catch(() => {
            if (seq !== this._staticImagesSeq) return;
            this.setState({ staticImages: [], staticImagesLoaded: true, staticImagesLoading: false });
        });
    }

    render() {
        const data = this.state.data;
        const tables = data.tables;
        const agents = this.props.agents;
        const propertyImage = this.props.data.WEBSITE_PHOTO_1 ? this.props.data.WEBSITE_PHOTO_1 : '';
        const disabled = !!this.props.readOnlySnapshot || !(editsEverySummitRecord(getCurrentAccess()) || this.props.agentIsCurrentUser && ['Proposal', 'Property Info', 'Off Market', 'Removed'].includes(this.props.data.STATUS));
        const isCategoryRetail = data.tables['general-information'].rows['property-category'].value === 'retail';
        const isPropertyIndustrialVacant = Object.keys(this.props.data).length && this.props.data.TYPE === "STNL" && this.props.data.CATEGORY === 'industrial' && (this.props.data.SINGLE_TENANT_SUBCATEGORY === 'Vacant' || this.props.data.LEASE_TYPE === 'Vacant');
        const isPropertyIndustrial = Object.keys(this.props.data).length && this.props.data.TYPE === "STNL" && this.props.data.CATEGORY === 'industrial' && !isPropertyIndustrialVacant;

        const isCategoryOffice = Object.keys(this.props.data).length && this.props.data.TYPE === "STNL" && this.props.data.CATEGORY === 'office';
        const isPropertyOfficeVacant = isCategoryOffice && this.props.data.LEASE_TYPE === 'Vacant';
        const isPropertyRetailVacant = isCategoryRetail && this.props.data.LEASE_TYPE === 'Vacant';
        const propertyMapProps = {
            LATITUDE: this.props.data.LATITUDE ? parseFloat(this.props.data.LATITUDE) : 0,
            LONGITUDE: this.props.data.LATITUDE ? parseFloat(this.props.data.LONGITUDE) : 0,
            NAME: this.props.data.NAME
        };
        const isSaleLeaseBack = data.tables['general-information'].rows['sale-lease-back'].value === "Yes"

        return (
            <div>
                <PopupDialog
                    title={this.state.dialogTitle}
                    isOpen={this.state.isDialogueOpen}
                    onConfirm={() => { this.onConfirm() }}
                    onCancel={() => { this.onCancel() }}
                />
                {this.state.staticImagesLoading ? (
                    <div className="Financials_print_assets_overlay" role="status" aria-live="polite" aria-busy="true">
                        <div className="Financials_print_assets_overlay_panel">
                            <div className="Financials_print_assets_overlay_spinner" aria-hidden="true" />
                            <p className="Financials_print_assets_overlay_message">Please wait, generating print assets...</p>
                        </div>
                    </div>
                ) : null}
                <PrintSingleTenant staticImages={this.state.staticImagesLoaded ? this.state.staticImages : defualtStaticImages} isCategoryRetail={isCategoryRetail} isCategoryOffice={isCategoryOffice} proposalData={this.props.proposalData} isPropertyIndustrialVacant={isPropertyIndustrialVacant}
                    isPropertyIndustrial={isPropertyIndustrial}
                    location={this.props.location} tables={tables} propertyImage={propertyImage} agents={agents} propertyMapProps={propertyMapProps} isPropertyOfficeVacant={isPropertyOfficeVacant} isPropertyRetailVacant={isPropertyRetailVacant} isSaleLeaseBack={isSaleLeaseBack} />
                <div className='Financials_content single_tenant_content'>
                    {/* <div onMouseEnter={this.togglePopupMessage} onMouseLeave={this.togglePopupMessage} className='placeholder-button'/> */}
                    {isCategoryRetail ? (
                        <label className='Financials_california_toggle'>
                            <input
                                type='checkbox'
                                checked={this.state.isCaliforniaProposal}
                                onChange={this.handleCaliforniaToggle}
                                disabled={this.state.staticImagesLoading}
                            />
                            <span>California Proposal{this.state.staticImagesLoading ? ' (loading...)' : ''}</span>
                        </label>
                    ) : null}
                    <button className={`Financials_submit_button${disabled ? '_disabled' : ''}`} onClick={this.beforeSubmit} disabled={disabled}>Submit</button>
                    {disabled && this.state.displayPopupSubmit ? <div className='Financials_submit_message'>Don't have permission to save.</div> : null}
                    <div className={`${isSaleLeaseBack ? 'Financials_general_information_columns ' : ''}`}>
                        <div className={`Financials_general_${isSaleLeaseBack ? 'rent_pricing_tables' : 'information_table'}`}>
                            {UnderwritingSingleTenant.renderTableContainer(tables, 'general-information', [this.renderTable(tables, 'general-information')], isSaleLeaseBack)}
                        </div>
                        {
                            isSaleLeaseBack && <div className='Financials_general_rent_pricing_tables'>
                                {UnderwritingSingleTenant.renderTableContainer(tables, 'pricing-rent-matrix', [this.renderPricingRentMatrix('pricing-rent-matrix', this.props.data),])}
                            </div>
                        }
                    </div>

                    <div className='Financials_list_columns'>
                        <div className='Financials_list_column'>
                            {UnderwritingSingleTenant.renderTableContainer(tables, 'offering-summary', [this.renderTable(tables, 'offering-summary')])}

                            {UnderwritingSingleTenant.renderTableContainer(tables, 'lease-summary', [this.renderTable(tables, 'lease-summary', this.props.data.CLOSE_OF_ESCROW)])}

                            {UnderwritingSingleTenant.renderTableContainer(tables, 'annualized-operating-data', [this.renderMatrixTable('annualized-operating-data')])}

                            {UnderwritingSingleTenant.renderTableContainer(tables, 'lease-notes', [
                                <Textarea
                                    type='text'
                                    key=""
                                    name='LEASE NOTES'
                                    readOnly={!!this.props.readOnlySnapshot}
                                    value={tables['lease-notes'].rows['lease-notes'].value}
                                    onChange={(event) => this.onTableValueChange('lease-notes', 'lease-notes', event)}
                                    label='Lease notes' />
                            ])}
                        </div>
                        <div className='Financials_list_column'>
                            {UnderwritingSingleTenant.renderTableContainer(tables, 'pricing-matrix', [this.renderMatrixTable('pricing-matrix'),])}

                            {UnderwritingSingleTenant.renderTableContainer(tables, 'pricing-matrix-annex', [this.renderMatrixTable('pricing-matrix-annex'),])}

                            {UnderwritingSingleTenant.renderTableContainer(tables, 'rent-schedule', [this.renderMatrixTable('rent-schedule')])}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}